import React from 'react';
import './Skeleton.css';

const Skeleton = ({
  variant = 'text',
  width,
  height,
  className = '',
  borderRadius,
  count = 1,
  style = {}
}) => {
  const skeletonStyle = {
    width,
    height,
    borderRadius,
    ...style
  };

  const skeletons = Array.from({ length: count }, (_, index) => (
    <div
      key={index}
      className={`skeleton skeleton-${variant} ${className}`}
      style={skeletonStyle}
    />
  ));

  return count === 1 ? skeletons[0] : <>{skeletons}</>;
};

export const SkeletonCard = ({ children, className = '' }) => (
  <div className={`skeleton-card ${className}`}>
    {children}
  </div>
);

export const SkeletonRow = ({ children, className = '' }) => (
  <div className={`skeleton-row ${className}`}>
    {children}
  </div>
);

export default Skeleton;
